import { NodeSpec } from "prosemirror-model";

export type TextAlignNodeAttributesPart = {
	textAlign: SupportedTextAlignOptions | undefined;
};

export type SetTextAlignNodeAttributesPart = NonNullableProperties<TextAlignNodeAttributesPart>;

export type SupportedTextAlignOptions = "left" | "right" | "center" | "justify";

export function parseTextAlign(htmlElement: HTMLElement): TextAlignNodeAttributesPart {
	const inlineTextAlignValue: string = htmlElement.style.textAlign;
	switch (inlineTextAlignValue) {
		case "left":
		case "right":
		case "center":
		case "justify":
			return {
				textAlign: inlineTextAlignValue
			};
		default:
			return {
				textAlign: undefined
			};
	}
}

export function generateTextAlignStyles(attrs: TextAlignNodeAttributesPart): {[key: string]: string;} {
	if (!attrs.textAlign) {
		return {};
	}

	return {
		"text-align": attrs.textAlign
	};
}

export type NodeSpecWithTextAlignSupport = {
	doesSupportTextAlign: true;
};

export function doesSupportTextAlign(nodeType: NodeSpec): nodeType is (NodeSpec & NodeSpecWithTextAlignSupport) {
	return (nodeType as NodeSpecWithTextAlignSupport).doesSupportTextAlign === true;
}

export function isTextAlignNodeAttributes(attrs: unknown): attrs is SetTextAlignNodeAttributesPart {
	if (typeof attrs !== "object" || attrs === null) {
		return false;
	}

	return typeof (attrs as TextAlignNodeAttributesPart).textAlign === "string";
}